'use client';
const DEFAULT_LOCALE = 'en-US';
const isServer = typeof window === 'undefined';

export { DEFAULT_LOCALE, isServer };
//# sourceMappingURL=constants.js.map
